import { Component, OnInit } from '@angular/core';
import { HttpService } from '../http.service';
import { SnackbarService } from '../snackbar.service';
import { TimeService } from "../time.service";

@Component({
  selector: 'app-sim-consent',
  templateUrl: './sim-consent.component.html',
  styleUrls: ['./sim-consent.component.scss']
})
export class SimConsentComponent implements OnInit {
  isPopupOpen = false;
  simConsentData:any = []
  lastSubscribedTimeStamp:number = new Date().getTime() - 3600000;
  jioConsentExpiry = 4*60*60*1000;
  othersConsentExpiry = 8*60*60*1000;
  consentRadioButton:Boolean = true
  filteredSIM:any = new Array()
  searchSIN:string = ""
  searchMobile:string = ""
  serviceProviders = [
    'airtel',
    'vodafone',
    'Jio',
    'idea',
    'aircel',
    'bsnl'
  ]
  serviceProvider:string = ''
  displayedColumns = [
    'Ind',
    'SIN',
    'Driver Name',
    'Driver Mobile',
    'Carrier Name',
    'Service Provider',
    'Subscription Time',
    'Resubscribe'
  ];
  constructor(private http: HttpService, private snackbar: SnackbarService, private timeService:TimeService) { }

  ngOnInit(): void {
    // console.log("simConsentComponent")
    this.getSimConsentData();
  }
  getSimConsentData() {
    const url = (this.consentRadioButton)?'/v1/shipment/simSubscriptionStatus':'/v1/shipment/simConsentStatus';
    this.http
      .get(url,"", 3)
      .subscribe(
        (data: any) => {
          this.simConsentData = data.data;
          this.simConsentData.map((item)=>{
            if(item.service_provider!=='Jio') item.service_provider = item.service_provider.slice(0,-3);
            if(this.consentRadioButton){
              this.setConsentExpiry(item);
              item.subscription_time = (item.subscription_time) ? this.timeService.toShortDateTime(item.subscription_time) : "N/A";
            }
            else{
              item.consent_time = (item.consent_time) ? this.timeService.toShortDateTime(item.consent_time) : "N/A";
            }
          })
          
        },
        (err: any) => {
          this.snackbar.openSnackBar(err.error.message, '', 'err');
        }
      );
  }

  setConsentExpiry(item:any){
    if(item.service_provider==='Jio'){
      item.isConsentExpired = (new Date().getTime() - new Date(item.subscription_time).getTime()) > this.jioConsentExpiry ? true : false;
    }
    else{
      item.isConsentExpired = (new Date().getTime() - new Date(item.subscription_time).getTime()) > this.othersConsentExpiry ? true : false;
    }
    console.log("consent expiry set", item.isConsentExpired)
  }

  makeChange(element:any, value:string){
    element.service_provider = value;
  }

  resubscribe(element:any){
    // console.log("event", event);
    const currentTimeStamp:number = new Date().getTime();
    console.log("time stamp",this.lastSubscribedTimeStamp, currentTimeStamp)
    if(currentTimeStamp - this.lastSubscribedTimeStamp >= 3600000){
      const payload = {
        id : element._id,
        serviceProvider : element.service_provider,
        isResubscribe : true,
      }
      this.http
        .post('/v1/shipment/simTrack/subscribe',payload, 5)
        .subscribe(
          (data: any) => {
            this.getSimConsentData();
            this.snackbar.openSnackBar('Resubscribed successfully', '', '');
            this.lastSubscribedTimeStamp = currentTimeStamp;
          },
          (err: any) => {
            this.snackbar.openSnackBar(err.error.message, '', 'err');
          }
        );
    }
    else{
      this.snackbar.openSnackBar(`You can resubscribe after ${Math.round(( this.lastSubscribedTimeStamp+3600000 - currentTimeStamp )/(60000))} mins`, '', 'err');
    }

  }

  filterSIN(){
      // console.log("in filterSIN", this.searchSIN)
      this.searchSIN = this.searchSIN.trim();
      if(this.searchSIN.length >=7 ){
        this.simConsentData.map((item)=>{
          // console.log("SIN NUmber",typeof item.sin ,typeof item.mobile)
          if(item.SIN.includes(this.searchSIN.toUpperCase())) this.filteredSIM.push(item);
        })
        this.simConsentData = this.filteredSIM;
        this.filteredSIM = [];
      }
  }

  filterMobile(){
    // console.log("search Mobile", this.searchMobile)
    this.searchMobile = this.searchMobile.trim();
    if(this.searchMobile.length >=9){
      this.simConsentData.map((item)=>{
        if(item.mobile.includes(this.searchMobile)) this.filteredSIM.push(item);
      })
      this.simConsentData = this.filteredSIM;
      this.filteredSIM = []
    }
}

toggleConsentAndLocation(flag:Number){
  this.consentRadioButton = (flag==1)?true:false;
  console.log("toggle flag",flag==1, this.consentRadioButton)
  this.getSimConsentData();
}

openPopup(){
  console.log("open popup called")
  this.isPopupOpen = true;
}
closePopup(){
  console.log("open popup called")
  this.isPopupOpen = false;
}

}
